<div>
  <i (click)="onClick.emit()" class="pi pi-plus plus-icon" tabindex="0" appEnterClick></i>
  <label class="field-label" for="add-foto-proof">
    {{ label }}
  </label>
</div>
